import { useEffect, useState } from 'react';
import { useApp } from './AppContext.js';
import { iniciais, rotuloPapel } from '../ui/lib/format.js';

/** Relógio ao vivo — detalhe de sala de operação; some com reduced-motion? não,
 *  é informação, não animação. Atualiza a cada segundo. */
function Relogio() {
  const [agora, setAgora] = useState(() => new Date());
  useEffect(() => {
    const id = setInterval(() => setAgora(new Date()), 1000);
    return () => clearInterval(id);
  }, []);
  return (
    <time className="clock" dateTime={agora.toISOString()}>
      {agora.toLocaleTimeString('pt-BR')}
    </time>
  );
}

/**
 * Barra superior: breadcrumb da tela atual + relógio + quem está logado.
 *
 * O título grande vive no corpo (PageHeader); aqui fica só o caminho, para não
 * repetir. Sem sessão o chip avisa em cor de alerta.
 */
export function Header({ secao, titulo }: { secao: string; titulo: string }) {
  const { sessao, roles } = useApp();

  return (
    <header className="header">
      <nav className="crumb" aria-label="Trilha">
        <span>{secao}</span>
        <span className="crumb__sep">/</span>
        <span className="crumb__here">{titulo}</span>
      </nav>
      <div className="header__spacer" />
      <div className="header__right">
        <Relogio />
        {sessao ? (
          <div className="userchip">
            <span className="userchip__name">{sessao.username}</span>
            <span className="avatar" title={rotuloPapel(roles)}>
              {iniciais(sessao.username)}
            </span>
          </div>
        ) : (
          <div className="userchip">
            <span className="userchip__name" style={{ color: 'var(--warning)' }}>sem sessão</span>
            <span className="avatar">?</span>
          </div>
        )}
      </div>
    </header>
  );
}
